export default [
    {
        path: 'my-projects',
        name: 'projects-my-projects',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./projects/my-projects',
            translate: (t) => {
                return t('menu_points.my_projects').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-my-projects-list' },
        children: [
            {
                path: '',
                name: 'projects-my-projects-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-projects',
                    translate: (t) => {
                        return t('menu_points.my_projects').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/projects/own.vue'),
                props: { own: true },
            },
            {
                path: 'create',
                name: 'projects-my-project-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-projects',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::projects.project', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/projects/item.vue'),
                props: { own: true },
            },
            {
                path: ':id(\\d+)',
                name: 'projects-my-project-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-projects',
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::projects.project', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/projects/item.vue'),
                props: { own: true },
            },
        ]
    },
    {
        path: 'accessible-projects',
        name: 'projects-accessible-projects',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./projects/accessible-projects',
            translate: (t) => {
                return t('menu_points.accessible_projects').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-accessible-projects-list' },
        children: [
            {
                path: '',
                name: 'projects-accessible-projects-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-projects',
                    translate: (t) => {
                        return t('menu_points.accessible_projects').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/projects/accessible.vue'),
            },
            {
                path: 'create',
                name: 'projects-accessible-project-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-projects',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::projects.project', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/projects/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-accessible-project-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-projects',
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::projects.project', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/projects/item.vue'),
            },
        ]
    },
    {
        path: 'my-offers',
        name: 'projects-my-offers',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./projects/my-offers',
            translate: (t) => {
                return t('menu_points.my_offers').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-my-offers-list' },
        children: [
            {
                path: '',
                name: 'projects-my-offers-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-offers',
                    translate: (t) => {
                        return t('menu_points.my_offers').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/offers/own.vue'),
                props: { own: true },
            },
            {
                path: 'create',
                name: 'projects-my-offer-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-offers',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::offers.offer', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/offers/item.vue'),
                props: { own: true },
            },
            {
                path: ':id(\\d+)',
                name: 'projects-my-offer-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-offers',
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::offers.offer', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/offers/item.vue'),
                props: { own: true },
            },
        ]
    },
    {
        path: 'accessible-offers',
        name: 'projects-accessible-offers',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./projects/accessible-offers',
            translate: (t) => {
                return t('menu_points.accessible_offers').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-accessible-offers-list' },
        children: [
            {
                path: '',
                name: 'projects-accessible-offers-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-offers',
                    translate: (t) => {
                        return t('menu_points.accessible_offers').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/offers/accessible.vue'),
                props: { accessible: true },
            },
            {
                path: 'create',
                name: 'projects-accessible-offer-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-offers',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::offers.offer', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/offers/item.vue'),
                props: { accessible: true },
            },
            {
                path: ':id(\\d+)',
                name: 'projects-accessible-offer-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-offers',
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::offers.offer', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/offers/item.vue'),
                props: { accessible: true },
            },
        ]
    },
    {
        path: 'my-contracts',
        name: 'projects-my-contracts',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./projects/my-contracts',
            translate: (t) => {
                return t('menu_points.my_contracts').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-my-contracts-list' },
        children: [
            {
                path: '',
                name: 'projects-my-contracts-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-contracts',
                    translate: (t) => {
                        return t('menu_points.my_contracts').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/contracts/own.vue'),
                props: { own: true },
            },
            {
                path: 'create',
                name: 'projects-my-contract-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-contracts',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::contracts.contract', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/contracts/item.vue'),
                props: { own: true },
            },
            {
                path: ':id(\\d+)',
                name: 'projects-my-contract-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-contracts',
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::contracts.contract', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/contracts/item.vue'),
                props: { own: true },
            },
        ]
    },
    {
        path: 'accessible-contracts',
        name: 'projects-accessible-contracts',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./projects/accessible-contracts',
            translate: (t) => {
                return t('menu_points.accessible_contracts').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-accessible-contracts-list' },
        children: [
            {
                path: '',
                name: 'projects-accessible-contracts-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-contracts',
                    translate: (t) => {
                        return t('menu_points.accessible_contracts').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/contracts/accessible.vue'),
                props: { accessible: true },
            },
            {
                path: 'create',
                name: 'projects-accessible-contract-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-contracts',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::contracts.contract', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/contracts/item.vue'),
                props: { accessible: true },
            },
            {
                path: ':id(\\d+)',
                name: 'projects-accessible-contract-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-contracts',
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::contracts.contract', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/contracts/item.vue'),
                props: { accessible: true },
            },
        ]
    },
    {
        path: 'my-implements',
        name: 'projects-my-implements',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./projects/my-implements',
            translate: (t) => {
                return t('menu_points.my_implements').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-my-implements-list' },
        children: [
            {
                path: '',
                name: 'projects-my-implements-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-implements',
                    translate: (t) => {
                        return t('menu_points.my_implements').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/implements/own.vue'),
                props: { own: true },
            },
            {
                path: 'create',
                name: 'projects-my-implement-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-implements',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::implements.implement', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/implements/item.vue'),
                props: { own: true },
            },
            {
                path: ':id(\\d+)',
                name: 'projects-my-implement-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/my-implements',
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::implements.implement', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/implements/item.vue'),
                props: { own: true },
            },
        ]
    },
    {
        path: 'accessible-implements',
        name: 'projects-accessible-implements',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: 'menu_points./projects/accessible-implements',
            translate: (t) => {
                return t('menu_points.accessible_implements').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-accessible-implements-list' },
        children: [
            {
                path: '',
                name: 'projects-accessible-implements-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-implements',
                    translate: (t) => {
                        return t('menu_points.accessible_implements').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/implements/accessible.vue'),
                props: { accessible: true },
            },
            {
                path: 'create',
                name: 'projects-accessible-implement-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-implements',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::implements.implement', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/implements/item.vue'),
                props: { accessible: true },
            },
            {
                path: ':id(\\d+)',
                name: 'projects-accessible-implement-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'menu_points./projects/accessible-implements',
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::implements.implement', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/implements/item.vue'),
                props: { accessible: true },
            },
        ]
    },
];